import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React from "react";
import { NetworkManager } from "../../Components/NetworkManager";
import { CommonUtil } from "../../utils/CommonUtil";
import { extractNodesEdges } from "../chatbottool/publishTemplate";
import { useNavigate } from "react-router-dom";
import { useProductsContext } from "../../Contexts/SidebarContext";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
import localizedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(localizedFormat);

const OptinFollowUpTable = ({ rows, setOptinTemplateList }: any) => {
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [page, setPage] = React.useState(0);
  const {
    saveNewNodeAndEdges,
    saveTemplates,
    saveTemplateName,
    setOptinFollow,
    setMenuTab,
  } = useProductsContext();
  const userTimezone = dayjs.tz.guess();

  const navigate = useNavigate();

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // Filter rows based on status
  const filteredRows = rows.filter(
    (row: any) => row.optinTemplateStatus === "Not Sent"
  );

  const onOptinTemplateNameClick = (
    e: any,
    optinTemplateId: string,
    optinTemplateName: string,
    scheduledTime: Date,
    listOfPayloads: String
  ) => {
    let getOptinTemplateId = "optinTemplateId=" + optinTemplateId;
    saveTemplateName({
      optinTemplateId,
      optinTemplateName,
      scheduledTime,
      listOfPayloads,
    });
    setMenuTab("chatbot");
    try {
      NetworkManager.sendJsonRequest(
        "getOptinTemplateData",
        "",
        getOptinTemplateId,
        "GET",
        true,
        onSuccessCall,
        onErrorCall
      );
    } catch (error) {}
  };

  const onSuccessCall = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData) {
      saveTemplates(respData.optinTemplateData);
      saveNewNodeAndEdges([], []);
      const result = extractNodesEdges(respData.optinTemplateData);
      const { nodes, edges } = result;
      saveNewNodeAndEdges(nodes, edges);
      setOptinFollow("optin");
      navigate(`/dashboard/chatbot`, { state: { create: false } });
    }
  };
  const onErrorCall = (err: any) => {};
  let rowsLength = filteredRows.length === 0;
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <TableContainer
          sx={{ height: rowsLength ? 200 : 380 }}
          className={`${rowsLength ? "" : "custom-scrollbar-css"}`}>
          <Table aria-label="simple table" stickyHeader>
            <TableHead>
              <TableRow sx={{ height: 60 }}>
                <TableCell sx={{ width: "170px", p: 1 }}> Name </TableCell>
                <TableCell sx={{ width: "200px", p: 1 }}>
                  {" "}
                  List Of Topics
                </TableCell>
                <TableCell sx={{ width: "80px" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row: any, index: any) => {
                  return (
                    <TableRow key={row.optinTemplateName}>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{ width: "170px", p: 1, cursor: "pointer" }}
                        // onClick={(e: any) =>
                        //   onOptinTemplateNameClick(
                        //     e,
                        //     row.optinTemplateId,
                        //     row.optinTemplateName,
                        //     row.scheduledTime,
                        //     row.listOfPayloads
                        //   )
                        // }
                      >
                        {row.optinTemplateName}
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "200px",
                          p: 1,
                          textTransform: "capitalize",
                        }}>
                        {row.listOfPayloads.join(", ")}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </>
  );
};
export default OptinFollowUpTable;
